import { API, API_GET } from "../../Config"

export const GetSubAdmins = () => {
    
  return (
    API_GET(API.GetSubadmin)
  )
}
